import { ArrowDropDown } from "@mui/icons-material";
import { Button, Menu, MenuItem } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useState } from "react";
import ReactGA from "react-ga4";
import { useHistory, withRouter } from "react-router-dom";
import LeaseAndSaleDropdownOptions from "../../../common/js/components/LeaseAndSaleDropdownOptions";
import RequestModalContainer from "../listing/RequestModalContainer";
import ConsultingApprovalModal from "../voucher/ConsultingDealApprovalModal";

const StyledGetPaid = styled(Button)(({ isPaidButton }) => ({
    ...(isPaidButton && {
        backgroundColor: "#43A047",
        borderColor: "#43A047",
        "&:hover": {
            backgroundColor: "#2e7031",
        },
        "&:active": {
            backgroundColor: "#2e7031",
        },
        "&:focus": {
            backgroundColor: "#2e7031",
        },
    }),
}));

const StyledMenuSubItem = styled(MenuItem)(() => ({
    fontSize: "14px",
    padding: "8px 20px",
    lineHeight: "1.42857143",
}));

const StyledActiveListingPrompt = styled("div")(() => ({
    fontSize: "14px",
    color: "#9e9e9e ",
    background: "rgb(250,250,250)",
    padding: "8px 20px",
    clear: "both",
}));

const OutsideCompModal = (props) => {
    const [createDealTypeSelectorOpen, setCreateDealTypeSelectorOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showApproveModal, setApproveModal] = useState(false);
    const [dealAnchorEl, setDealAnchorEl] = useState(null);

    const { dashboard, internal, toggleRequestModal } = props;
    const history = useHistory();

    const handleShowModal = (spaceType, transactionType) => {
        if (transactionType === "Consulting") {
            setApproveModal(true);
            return;
        }
        setShowModal(!showModal);
        toggleRequestModal(spaceType, transactionType);
    };

    const handleShowApproveModal = () => {
        setApproveModal(!showApproveModal);
    };

    const handleAgreeSubmit = (showModal) => {
        handleShowApproveModal(showModal);
        setShowModal(!showModal);
        toggleRequestModal(null, "Consulting");
    };

    const handleDisplayActiveListings = () => {
        history.push("/listings?tab=broker_open");
    };
    const handleCreateFromActiveListing = () => {
        setCreateDealTypeSelectorOpen(false);
        triggerEventFromDropdownRequest("existing");
        handleDisplayActiveListings();
    };

    const handleCreateWithoutListing = () => {
        setCreateDealTypeSelectorOpen(true);
        triggerEventFromDropdownRequest("new");
    };

    const triggerEventFromDropdownRequest = (newOrExisting) => {
        if (internal && dashboard) {
            ReactGA.event("Get Paid", {
                newOrExisting: newOrExisting,
            });
        } else if (internal) {
            ReactGA.event("New Deal Request", {
                newOrExisting: newOrExisting,
            });
        }
    };

    const dropDownTitle =
        internal && dashboard ? "Get Paid" : internal && !dashboard ? "Create New Deal" : "Create External Comp";
    const modalType =
        internal && dashboard ? "internal-comp" : internal && !dashboard ? "internal-comp" : "outside-comp";

    const handleDealDropdown = (event) => {
        setCreateDealTypeSelectorOpen(false);
        setDealAnchorEl(event.currentTarget);
    };

    const handleCloseDealDropdown = () => {
        setDealAnchorEl(null);
    };

    return (
        <React.Fragment>
            <StyledGetPaid
                id="Request-Deal-Dropdown"
                aria-controls={Boolean(dealAnchorEl) ? "Request-Deal-Menu" : undefined}
                aria-haspopup="true"
                aria-expanded={Boolean(dealAnchorEl) ? "true" : undefined}
                onClick={handleDealDropdown}
                variant="contained"
                endIcon={<ArrowDropDown />}
                isPaidButton={internal && dashboard}
            >
                {dropDownTitle}
            </StyledGetPaid>
            <Menu
                id="Request-Deal-Menu"
                anchorEl={dealAnchorEl}
                open={Boolean(dealAnchorEl)}
                onClose={handleCloseDealDropdown}
                anchorOrigin={{
                    vertical: "bottom", // Align the top of the menu with the bottom of the button
                    horizontal: "right", // Align the right edge of the menu with the right edge of the button
                }}
                transformOrigin={{
                    vertical: "top", // Align the bottom of the menu with the top of the button
                    horizontal: "right", // Align the left edge of the menu with the right edge of the button
                }}
                sx={{
                    "& .MuiPaper-root": {
                        position: "absolute",
                        width: internal && dashboard ? "300px" : "230px",
                        height: "auto",
                        boxShadow: "0 6px 12px rgba(0, 0, 0, 0.175)",
                        overflowY: "scroll",
                        maxHeight: "69vh",
                    },
                }}
            >
                {internal && !createDealTypeSelectorOpen && (
                    <React.Fragment>
                        <StyledActiveListingPrompt disableAutoFocusItem>
                            Do you have an active KM Listing to remove in KM Connect / Kidder.com for this Deal?
                        </StyledActiveListingPrompt>
                        <StyledMenuSubItem onClick={() => handleCreateFromActiveListing()}>Yes</StyledMenuSubItem>
                        <StyledMenuSubItem onClick={() => handleCreateWithoutListing()}>No</StyledMenuSubItem>
                    </React.Fragment>
                )}
                {(createDealTypeSelectorOpen || !internal) && (
                    <LeaseAndSaleDropdownOptions
                        addNoListingText={internal}
                        addConsultingBlock={internal}
                        callback={handleShowModal}
                    />
                )}
            </Menu>
            <ConsultingApprovalModal
                handleShowApproveModal={handleShowApproveModal}
                handleAgreeSubmit={handleAgreeSubmit}
                showModal={showApproveModal}
            />
            <RequestModalContainer
                {...props}
                handleShowModal={handleShowModal}
                showModal={showModal}
                modalType={modalType}
            />
        </React.Fragment>
    );
};

export default withRouter(OutsideCompModal);
